export default {
    "name": "HomeSetUserSetting",
    "kind": "HoudiniMutation",
    "hash": "495616ad763495307bbc257400967302277093cac087f9e729c359b50476b4b1",

    "raw": `mutation HomeSetUserSetting($input: SetUserSettingInput!) {
  setUserSetting(input: $input)
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "setUserSetting": {
                "type": "Boolean",
                "keyRaw": "setUserSetting(input: $input)",
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "SetUserSettingInput"
        },

        "types": {
            "SetUserHomeSettingInput": {
                "defaultCustomerContactCorrespondencesPerPage": "Int",
                "defaultCustomerContactCreatedDateRange": "String",
                "defaultCustomerContactDateRange": "String",
                "defaultCustomerContactShowClosed": "Boolean",
                "defaultCustomerContactShowOnlyMyCorrespondences": "Boolean",
                "defaultCustomerContactStore": "Int",
                "defaultDocumentTabSelection": "String",
                "defaultPurchaseOrderHistoryDateRange": "String",
                "defaultPurchaseOrderStoreFilter": "String",
                "defaultSalesOrderHistoryDateRange": "String",
                "defaultSalesOrderStoreFilter": "String",
                "defaultShowClosedWorkOrders": "Boolean",
                "defaultShowEstimateWorkOrders": "Boolean",
                "defaultTransferOrderHistoryDateRange": "String",
                "defaultTransferOrderStoreFilter": "String",
                "defaultWorkOrderHistoryDateRange": "String",
                "defaultWorkOrderStoreFilter": "String",
                "documentsPerPage": "Int",
                "linksOpenNewBrowserWindows": "Boolean",
                "messageOfTheDayHeight": "Int"
            },

            "SetUserPartsSettingInput": {
                "clearScreenOnSave": "Boolean",
                "defaultNewAttachmentsArePublic": "Boolean"
            },

            "SetUserReportViewerSettingInput": {
                "reportNames": "String"
            },

            "SetUserReportViewerHistorySettingInput": {
                "pageSize": "Int",
                "showCancelledJobs": "Boolean",
                "showDelayedJobsOnly": "Boolean",
                "showFailedJobs": "Boolean",
                "showReadyJobs": "Boolean",
                "showSentJobs": "Boolean"
            },

            "SetUserPartSearchSettingInput": {
                "pinnedSearchFields": "String"
            },

            "SetUserVehicleSearchSettingInput": {
                "pinnedSearchFields": "String"
            },

            "SetUserVehiclesSettingInput": {
                "defaultNewAttachmentsArePublic": "Boolean"
            },

            "SetUserSettingInput": {
                "home": "SetUserHomeSettingInput",
                "parts": "SetUserPartsSettingInput",
                "reportViewer": "SetUserReportViewerSettingInput",
                "reportViewerHistory": "SetUserReportViewerHistorySettingInput",
                "searchParts": "SetUserPartSearchSettingInput",
                "searchVehicles": "SetUserVehicleSearchSettingInput",
                "vehicles": "SetUserVehiclesSettingInput"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=bd16ff9ad91e2f268fa88d5ae6f27bd6335dd6186dc4bd934c294ae861da8d4a";